export default __webpack_public_path__ + "static/media/star_tier.50e4a73b.svg";